<template>
  <div
    :id="id"
    class="status-message def-status-message"
    :class="`status-message--${variant}`"
    :role="computedRole"
    :aria-live="computedAriaLive"
    :aria-atomic="ariaAtomic"
  >
    <slot>{{ text }}</slot>
  </div>
</template>

<script>
export default {
  name: "StatusMessage",
  props: {
    id: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "warning",
      validator: value => ["info", "success", "warning", "error"].includes(value),
    },
    role: {
      type: String,
      default: null,
    },
    ariaLive: {
      type: String,
      default: null,
    },
    ariaAtomic: {
      type: String,
      default: "true",
    },
  },
  computed: {
    computedAriaLive() {
      if (this.ariaLive) {
        return this.ariaLive;
      }
      return this.variant === "error" ? "assertive" : "polite";
    },
    computedRole() {
      if (this.role) {
        return this.role;
      }
      return this.computedAriaLive === "assertive" ? "alert" : "status";
    },
  },
};
</script>

<style scoped>
.status-message {
  display: block;
}
</style>

